exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".buildingBlock.field {\r\n  background: steelblue;\r\n  color: #fff;\r\n  padding: 0em 0.75em;\r\n  margin-right: 0.25rem;\r\n  height: 1.5rem;\r\n  border-color: transparent;\r\n  border-radius: 1.5rem;\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n.buildingBlock.field .icon {\r\n  margin-right: 0.25rem;\r\n  font-size: 14px;\r\n}\r\n.buildingBlock.field .delete {\r\n  margin-left: 0.25rem;\r\n  color: #fff;\r\n}\r\n.buildingBlock.field .delete:hover {\r\n  color: #fff;\r\n}", ""]);

// exports
